module.exports = __webpack_public_path__ + "static/media/typewriter.c4974d8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/typewriter.png
// module id = 21
// module chunks = 0